<template>
  <div class="BeginSurvey">
    <!--<div class="balls"></div>-->
    <!-- Navigation -->
    <HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" :qtProjNumber="qtProjNumber" :key="qtSomos" />
    <!-- Page Content -->
    <div class="container-fluid">
      <div class="container container-content border-left-light py-3 py-md-5">
        <div class="row mt-lg-3">
          <div class="col-lg-6 pb-5 px-4 pr-lg-0 pb-lg-0 pl-lg-5">
            <div>
              <h3 class="text-second-color extra-bold">
                {{ template.title }}
              </h3>
              <h5 class="text-first-color light pr-md-5 pt-2">
                {{ template.subtitle }}
              </h5>
              <p v-if="template.text" class="text-second-color light t-1">
                {{ template.text }}
              </p>
            </div>
          </div>
          <div class="col-lg-6 px-4 pr-lg-0 pl-lg-5">
            <div class="row">
              <div class="col-12" v-if="template.items">
                <p v-if="template.info" class="text-second-color light mb-2">
                  <strong>{{ template.info }}</strong>
                </p>
                <h6
                  v-for="(item, index) in template.items"
                  :key="index"
                  class="text-first-color pr-md-5 mb-2"
                >
                  {{ item }}
                </h6>
                <p v-if="template.message" class="text-second-color light">
                  {{ template.message }}
                </p>
              </div>
              <div class="col-12 col-lg-6">
                <button
                  :style="
                    style.homeBtnColor
                      ? { backgroundColor: style.homeBtnColor }
                      : ''
                  "
                  type="submit"
                  class="btn btn-home btn-block my-3"
                  v-on:click="submit"
                >
                  {{ $t('start') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" :qtProjNumber="qtProjNumber" />
  </div>
</template>

<script>
import HeaderGlobal from "./HeaderGlobal.vue";
import FooterGlobal from "./FooterGlobal.vue";
/*
import { Survey } from "../services/Survey.js";
const s = new Survey();
*/
export default {
  name: "BeginSurvey",
  components: {
    HeaderGlobal,
    FooterGlobal,
  },
  data: () => ({
    qtSomos: 0,
    qtProjNumber: 0,
  }),
  created() {
    this.qtSomos = this.$store.state.qtUsers;
    this.qtProjNumber = this.$store.state.qtProjNumber;

    //this.qtSomos = this.$store.state.qtUsers;
  },
  computed: {
    template() {
      return this.$store.state.template.beginSurvey;
    },
    style() {
      return this.$store.state.template.style;
    },
  },
  methods: {
    submit() {
      this.$router.push("survey");
    },
  },
};
</script>
